<ng-container *ngIf="container$ | async as container">
	<stages-association-list
		[associationStore]="$any(associationStore)"
		[groups]="asArray(container.associationGroups)"
		[messageKeyNone]="messageKeyNone"
		[editable]="false"
		[allowCreateElements]="false"
		[class]="classes"
		[container]="$any(container)"
		[showProcessInterfaceName]="true"
	>
	</stages-association-list>
</ng-container>
